<template>
    <div class="AIpage">
        <div class="chart">
            <div class="header">
                <div class="title">智能咨询</div>
                <div class="center"></div>
                <div class="right">问题规范</div>
            </div>
            <div class="chatBox scrollbar" id="chatContainer">
                <div class="chatList">
                    <div class="chatItem"
                         v-for="(item,index) in chatList"
                         :key="index">
                        <div class="chatBoxs" :class="item.isMe ? 'me' :'your'">
                            <div v-if="item.type == 1" class="text chatContent">
                                {{item.msg}}
                            </div>
                            <img class="chatContent img" v-if="item.type==2" :src="item.msg | imgUrl(2)" alt="">

                            <div v-if="item.type==3" class="chatContent answersBox">
                                <div>
                                    {{item.res}}
                                </div>
                                <ul class="answers">
                                    <li class="question"
                                        v-for="(items,indexs) in item.answers" :key="indexs"
                                        @click="sendMsg(items.name)"
                                    >
                                        {{items.name}}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="clear"></div>

                </div>
            </div>
            <div class="chatNav">
                <div class="navList">
                    <div class="navTitle">热门主题</div>
                    <div class="navItem" v-for="(item,index) in HotTopicsData" :key="index"
                         @click="sendMsg(item.name)">
                        {{item.name}}
                    </div>
                </div>
            </div>
            <div class="chatInput">
                <textarea class="textareaInput scrollbar"
                          @keyup.enter="sendMsg()"
                          name="textarea" id="msg" rows="3"
                          v-model="msg"
                          placeholder="请输入您想问的问题~~"></textarea>
                <div class="sendMsg" @click="sendMsg()">
                    发送
                </div>
            </div>
        </div>
        <div class="AIListContent">
            <div class="header">常见问题</div>
            <div class="AIList scrollbar">
                <div class="AIItem" v-for="(item,index) in FaqData" :key="index" @click="sendMsg(item.name)">
                    <div class="text">{{item.name}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import apiUrl from '../utils/UrlApi'

    export default {
        name: "AIChart",
        data() {
            return {
                chatList: [],
                msg: '',
                HotTopicsData: [],
                FaqData: [],
            }
        },
        computed: {
            userId: {
                get() {
                    return this.$store.state.userId;
                },
                set(val) {
                    this.$store.commit("updateUserId", val);
                }
            },
            gpsState: {
                get() {
                    return this.$store.state.gpsState;
                },
                set(val) {
                    this.$store.commit('updateGpsState', val);
                }
            },
        },
        created() {
            console.log(this.userId)
            // debugger
            if (typeof (WebSocket) === 'undefined') {
                alert('您的浏览器不支持socket')
            } else {
                this.initWebsocket()	// 初始化websocket
            }

            this.getHotTopics()
            this.getFaq()
        },
        // mounted(){
        //     if (typeof (WebSocket) === 'undefined') {
        //         alert('您的浏览器不支持socket')
        //     } else {
        //         if (this.userId){
        //             this.initWebsocket()	// 初始化websocket
        //         }
        //     }
        // },
        methods: {
            // 初始化websocket
            initWebsocket() {
                // getUrl()访问服务器获取ip地址方法
                console.log('Lianjie')
                this.$notify.close()
                // let token =localStorage.getItem('token')
                // let token ='1'
                // console.log(token)
                // getUrl().then(res => {
                // 地址通过后端获取
                // this.path = res.data.data
                // this.websock = new WebSocket('ws://' + this.path + ':8080/websocket/' + getUser())
                // this.websock = new WebSocket(apiUrl.websocket)
                this.websock = new WebSocket(apiUrl.websocket + localStorage.getItem('userId'), localStorage.getItem('token'))
                // this.websock = new WebSocket(apiUrl.websocket + '1cf6a33f43b0423482d7413a42b761aa', localStorage.getItem('token'))
                this.websock.onopen = this.websocketonopen
                this.websock.onerror = this.websocketonerror
                this.websock.onmessage = this.websocketonmessage
                this.websock.onclose = this.websocketclose
                // 路由跳转时结束websocket链接
                this.$router.afterEach(function () {
                    this.websock.close()
                })
                // })
            },
            // 打开连接
            websocketonopen() {
                // this.websocketsend(JSON.stringify({type: '1', message: '确认消息'}))
                console.log('WebSocket连接成功')
            },
            // 连接错误
            websocketonerror(e) {
                console.log('WebSocket连接发生错误')
                // this.$message.error('WebSocket连接发生错误')
                // this.$notify.error({
                //     title: '错误',
                //     message: 'WebSocket连接发生错误,正在重连中....'
                // });
                // this.initWebsocket()
            },
            // 数据接收
            websocketonmessage(e) {
                // console.log(e)
                // console.log('数据已接收...')

                let data

                try {
                    data = JSON.parse(e.data)
                } catch (e) {
                    console.error('接收数据非JSON')
                    data = {}
                }


                // console.log(data)
                //  过滤心跳消息
                if (data.type != 0 && data.type) {
                    this.chatList.push(data)
                }

                console.log(this.websock)
            },
            // 数据发送
            websocketsend(agentData) {
                console.log(this.websock)

                if (this.websock.readyState !== 1) {
                    this.$notify.error({
                        title: '错误',
                        message: 'WebSocket连接发生错误,正在重连中....'
                    });
                    this.initWebsocket()
                } else {

                    this.websock.send(agentData)
                    this.msg = ''
                    this.chatList.push(JSON.parse(agentData))
                }

            },
            // 关闭连接
            websocketclose() {
                console.log('connection closed')
                this.websock.close()
            },
            sendMsg(msg) {
                let data = {
                    type: '1',
                    msg: '',
                    city: this.gpsState.city,
                    isMe: true
                }
                if (msg || this.msg) {
                    data.msg = msg || this.msg
                    this.websocketsend(JSON.stringify(data))
                } else {
                    console.log('发送数据为空')
                }
            },


            //     获取热门主题
            getHotTopics() {

                let data = {}
                this.$http.get(apiUrl.aiHotTopics, data).then(res => {
                    console.log(res)

                    if (res.data.code === '200') {

                        this.HotTopicsData = res.data.data

                    } else {
                        this.$message.error(res.data.message)
                    }

                })

            },
            //     获取常见问题
            getFaq() {
                let data = {}
                this.$http.get(apiUrl.aiFaq, data).then(res => {
                    console.log(res)

                    if (res.data.code === '200') {
                        this.FaqData = res.data.data

                    } else {
                        this.$message.error(res.data.message)
                    }

                })
            }
        },

        watch: {
            chatList() {
                // console.log("chatlog change");
                this.$nextTick(() => {
                    var container = this.$el.querySelector("#chatContainer");
                    // console.log(container);
                    container.scrollTop = container.scrollHeight;
                })
                // document.getElementById('chatContainer').scrollTop = document.getElementById('chatContainer').scrollHeight+150;

            }
        },
        //离开当前页面后执行
        destroyed: function () {
            this.websocketclose();
        },
    }
</script>

<style scoped lang="less">
    .AIpage {
        max-height: 540px;
        flex: 1;
        display: flex;
        width: 1200px;
        margin: 4px auto;
        background-color: #fff;
        border-radius: 20px;
        padding: 10px 20px;
        box-shadow: 3px 3px 3px 3px #ddd;
        .chart {
            flex: 1;
            display: flex;
            flex-direction: column;
            border-right: 1px solid #ddd;
            .header {
                display: flex;
                align-items: center;
                .title {
                    width: 100px;
                    text-align: center;
                    font-size: 20px;
                    font-weight: bold;
                    color: #333;
                }
                .center {
                    flex: 1;
                }
                .right {
                    width: 100px;
                    text-align: center;
                    font-size: 16px;
                    font-weight: bold;
                    color: #333;
                }
            }
            .chatBox {
                flex: 1;
                overflow: auto;
                /*border: 1px solid #ddd;*/
                background-color: #e3f7fe;
                padding: 10px 0;
                .chatList {
                    .chatItem {
                        margin-bottom: 16px;
                        clear: both;

                        .chatBoxs{
                            max-width: 60%;
                            padding: 0 10px;
                            .answers {
                                margin-top: 4px;
                                .question {
                                    color: #1daaf1;
                                    text-indent: 10px;
                                    cursor: pointer;
                                }
                            }
                            .text {
                                padding: 8px;
                                word-break: break-all
                            }

                            .chatContent {
                                padding: 8px;
                            }
                            .img {
                                display: inline;
                            }
                            .answersBox {
                            }

                        }
                    }
                    .your {
                        float: left;
                        border-top-right-radius: 10px;
                        border-bottom-right-radius: 10px;
                        background-color: #ffffff;
                        margin-left: 10px;
                        position: relative;

                        img {
                            max-width: 100%;
                        }
                    }
                    .your:after {
                        content: '';
                        position: absolute;
                        width: 0;
                        height: 0;
                        border: 8px solid transparent;
                        border-right-color: #fff;
                        right: 100%;
                        bottom: 10px;
                        margin-top: -7px;
                    }
                    .me {
                        float: right;
                        border-top-left-radius: 10px;
                        border-bottom-left-radius: 10px;
                        background-color: #b4ffb2;
                        margin-right: 10px;
                        position: relative;
                        /*text-align: right;*/
                        /*.text {*/
                        /*border-top-left-radius: 10px;*/
                        /*border-bottom-left-radius: 10px;*/
                        /*display: inline;*/
                        /*background-color: #b4ffb2;*/
                        /*}*/
                        /*.text:after {*/
                        /*content: '';*/
                        /*position: absolute;*/
                        /*width: 0;*/
                        /*height: 0;*/
                        /*border: 8px solid transparent;*/
                        /*border-left-color: #b4ffb2;*/
                        /*left: 100%;*/
                        /*bottom: 10px;*/
                        /*margin-top: -7px;*/
                        /*}*/
                    }
                    .me:after {
                        content: '';
                        position: absolute;
                        width: 0;
                        height: 0;
                        border: 8px solid transparent;
                        border-left-color: #b4ffb2;
                        left: 100%;
                        bottom: 10px;
                        margin-top: -7px;
                    }

                }
            }
            .chatNav {
                padding: 10px;
                border-bottom: 1px solid #ddd;
                .navList {
                    display: flex;
                    align-items: center;
                    .navTitle {
                        margin-right: 20px;
                        color: red;
                    }
                    .navItem {
                        border: 1px solid #ccc;
                        box-shadow: 1px 1px 1px 1px #ddd;
                        padding: 4px 10px;
                        margin: 0 10px;
                        border-radius: 8px;
                        cursor: pointer;
                    }
                }
            }
            .chatInput {
                position: relative;
                .textareaInput {
                    width: 100%;
                    padding: 10px;
                    outline: none;
                    border: none;
                    resize: none;
                }
                .sendMsg {
                    position: absolute;
                    text-align: center;
                    padding: 4px 13px;
                    box-shadow: 1px 1px 1px 1px #aaa;
                    cursor: pointer;
                    border-radius: 4px;
                    color: #000;
                    font-weight: bold;
                    background-color: #aaa;
                    border: 1px solid #aaa;
                    right: 6px;
                    bottom: 4px;
                }
            }
        }
        .AIListContent {
            width: 340px;
            display: flex;
            flex-direction: column;
            .header {
                text-align: center;
                font-size: 16px;
                font-weight: bold;
                color: #333;
            }
            .AIList {
                flex: 1;
                /*max-height: 540px;*/
                overflow: auto;
                .AIItem {
                    display: flex;
                    padding-left: 30px;
                    margin: 20px 0;
                    cursor: pointer;
                    .text {
                        font-size: 16px;
                    }
                    &:before {
                        content: "";
                        position: relative;
                        display: block;
                        left: -10px;
                        top: 10px;
                        width: 6px;
                        height: 6px;
                        border-radius: 50%;
                        background-color: #ccc;
                    }
                    &:hover {
                        color: #4059e5;
                    }
                }
            }
        }
    }

    .header {
        height: 32px;
        line-height: 32px;
        border-bottom: 1px solid #ddd;
    }

    .clear {
        clear: both;
    }
</style>